import React, { useEffect, useState } from "react";
import { MenuItem, Select } from "@mui/material";
import i18next from '../i18n';
import ApiClient from "../api/ApiClient";
import PromiseBuilder from "../utils/PromiseUtils";
import { useNotifications } from "../hooks/notification/notificationHook";
import { useTranslation } from "react-i18next";

export const I18N_CONFIG_KEY = "jobbit-i18nConfig";

const initialState = {
  code: "GB"
};

export function getConfig() {
  const ls = localStorage.getItem(I18N_CONFIG_KEY);
  if (ls) {
    try {
      return JSON.parse(ls);
    } catch (er) {
      console.error(er);
    }
  }
  return initialState;
}

const LanguageSelector = () => {
  const { t } = useTranslation();
  const lang = getConfig();
  const [languages, setLanguages] = useState([]);
  const { addErrorNotification } = useNotifications();

  const loadLanguages = () => {
    new PromiseBuilder()
      .then(async () => 
        ApiClient.get("/api/v1/country")
      )
      .then(async (res) => {
        setLanguages(res.data.countries);
      })
      .catch(async (e) => {
        addErrorNotification(t("toast.fetchCountriesFailed"), t("toast.error"));
        console.log("ERROR", e);
      })
      .run();
  }

  useEffect(() => {
    loadLanguages();
  }, []);

  useEffect(() => {
    i18next.changeLanguage(lang.code.toLowerCase());
   
  }, [languages]);

  const setLanguage = (language) => {
    localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({ code: language }));
  }

  return (

    <Select
      sx={{
        color: "white",
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0)',
        },
        '.MuiSvgIcon-root ': {
          fill: "white !important",
        }
      }}
      name='Language selection'
      style={{ color: 'white' }}
      IconComponent={props => (
        <></>
      )}
      value={lang.code}
      onChange={(_, newValue) => {

        i18next.changeLanguage(newValue.props.value.toLowerCase());
        setLanguage(newValue.props.value);
      }}
    >
      {languages.map((language) => (
        <MenuItem key={language.code} value={language.code}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
            <div
              className="tag bg bg-color-white"
              style={{ marginRight: '10px', padding: '2px 6px' }}>
              <img
                loading="lazy"
                srcSet={`https://flagcdn.com/w40/${language.code.toLowerCase()}.png 2x`}
                src={`https://flagcdn.com/w20/${language.code.toLowerCase()}.png`} />
            </div>
            {language.languageEnglishName ?? language.languageEnglishName}
          </div>
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSelector;